import { CHECKOUT_STEPS } from "@repo/constants/checkout";
import { useAddShippingInfoEvent } from "@repo/lib/hooks/gtm";
import { useState } from "react";

const useStepper = (session, cart) => {
  const [activeStepper, setActiveStepper] = useState(
    session ? CHECKOUT_STEPS.ADDRESS : CHECKOUT_STEPS.ACCOUNT
  );
  const [completedSteps, setCompletedSteps] = useState({
    [CHECKOUT_STEPS.ACCOUNT]: !!session,
  });
  const { handleAddShippingInfoEvent } = useAddShippingInfoEvent();

  const handleStepChange = (step) => {
    // Prevent going back to the Account step if logged in
    if (step === CHECKOUT_STEPS.ACCOUNT && session) return;

    // Only allow changing to steps that are completed or the current step
    if (completedSteps[step] || step === activeStepper) {
      setActiveStepper(step);
    }
  };

  const handleAddressComplete = () => {
    setCompletedSteps((prev) => ({
      ...prev,
      [CHECKOUT_STEPS.ADDRESS]: true,
    }));
    handleAddShippingInfoEvent(cart);
    setActiveStepper(CHECKOUT_STEPS.SHIPPING);
  };

  const handleGuestSelection = () => {
    setCompletedSteps((prev) => ({
      ...prev,
      [CHECKOUT_STEPS.ACCOUNT]: true,
    }));
    setActiveStepper(CHECKOUT_STEPS.ADDRESS);
  };

  return {
    activeStepper,
    setActiveStepper,
    completedSteps,
    setCompletedSteps,
    handleStepChange,
    handleAddressComplete,
    handleGuestSelection,
  };
};

export default useStepper;
